import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap5';
import * as Yup from 'yup';
import { Formik, Form as FormikForm } from 'formik';

import LoadingPlaceholder from 'components/new_ui/WaitLayers/LoadingPlaceholder';
import Modal from 'components/new_ui/Modal/Modal';
import HorizontalTextField from 'components/new_ui/Form/HorizontalTextField';
import { useContext } from 'components/Managers/Teams/Context';

export default function Index({ show, onCloseClick }) {
  const { state, dispatch, actions } = useContext();

  const formSchema = Yup.object().shape({
    title: Yup.string().required('Title is required'),
  });

  const onSubmitHundler = (values, { setSubmitting, setErrors }) => {
    const params = {
      ...values,
      enterprise_id: state.enterpriseId,
    };

    actions.create(
      dispatch,
      params,
      () => {
        setSubmitting(false);
        onCloseClick();
      },
      (errorData) => {
        const newErrors = {};
        errorData.errors.forEach((item) => {
          newErrors[item.source.pointer.replace('/data/attributes/', '')] = item.detail;
        });
        setErrors(newErrors);
        setSubmitting(false);
      },
    );
  };

  return (
    <Modal show={show}>
      <Formik
        validationSchema={formSchema}
        initialValues={{
          title: '',
        }}
        onSubmit={onSubmitHundler}
      >
        {({ isSubmitting }) => (
          <FormikForm className="needs-validation" noValidate="">
            <HorizontalTextField name="title" label="Title" required />

            <footer>
              <Button
                variant="outline-primary"
                disabled={isSubmitting}
                onClick={() => onCloseClick()}
              >
                Cancel
              </Button>

              <Button
                type="submit"
                disabled={isSubmitting}
              >
                {isSubmitting && (
                  <LoadingPlaceholder placement="inline" text=" " />
                )}
                Save
              </Button>
            </footer>
          </FormikForm>
        )}
      </Formik>
    </Modal>
  );
}

Index.propTypes = {
  show: PropTypes.bool.isRequired,
  onCloseClick: PropTypes.func.isRequired,
};
